import { render, staticRenderFns } from "./checkout-stepper.vue?vue&type=template&id=5fb0b80d&"
import script from "./checkout-stepper.vue?vue&type=script&lang=js&"
export * from "./checkout-stepper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports